import useLanguage from '@op/hooks/useLanguage';
import { TimePicker } from 'tea-component';
import moment, { Moment } from 'moment';
import React, { useMemo } from 'react';
const { RangePicker } = TimePicker;

export default function TimeRangeSelect({
  setFilterTime,
  timeFilterValue,
  setTimeFilterValue,
}: {
  setFilterTime: (value: { startTime: string; endTime: string }) => void;
  timeFilterValue: { startTime: string; endTime: string };
  setTimeFilterValue: (value: { startTime: string; endTime: string }) => void;
}) {
  const { formatMessage } = useLanguage();

  // 获取时间的开始和结束时间 如果改变日期，这里value会返回[null, null]
  const onChangeRangePicker = (value: [Moment, Moment]) => {
    const [s, e] = value;
    const date = {
      startTime: s.format('HH:mm'),
      endTime: e.format('HH:mm'),
    };
    setFilterTime(date);
    setTimeFilterValue(date);
  };

  const rangePickerValue = useMemo((): [Moment, Moment] => {
    const { startTime = "00:00", endTime= "23:55" } = timeFilterValue || {}; 
    return [moment(startTime, 'HH:mm'), moment(endTime, 'HH:mm')];
  }, [timeFilterValue]);

  return (
    <div className="dbo-time-range-select">
      <label style={{ marginRight: 10 }}>{formatMessage('Stream Time')}</label>
      <RangePicker
        caption={[formatMessage('Start Time'), formatMessage('End Time')]}
        value={rangePickerValue}
        format={'HH:mm'}
        minuteStep={5}
        onChange={onChangeRangePicker}
      />
    </div>
  );
}
